module.exports = __webpack_public_path__ + "media/public/img/top-of-the-rock-logo-9bc13a44cc84cbc9dbd4a6b1e40e1fbc.svg";